<div class="payment-modes-list">
  @if (sbrfItem(); as sbrfItem) {
    <div class="payment-modes-list-item text-b3-s-300 text-lg-b4-m-300 color-black">
      <sd-radio
        type="radio"
        name="checkout-payment-mode"
        [ngModel]="activePaymentMode()"
        (ngModelChange)="onBindNewCardClicked()"
        [value]="null"
      >
        <span class="color-black">новой картой</span>
      </sd-radio>
      <sd-icon [type]="iconTypes.NEWCARD" class="icon-size-m"></sd-icon>
    </div>

    @if (bankCardsList(); as bankCardsList) {
      @for (bankCardItem of bankCardsList; track bankCardItem.bindingId) {
        <div class="payment-modes-list-item-wrapper">
          @let isItemDisabled = !!sbrfItem.disableWhenCanNotPayInplace && !canPayInplace();

          <div class="payment-modes-list-item text-b3-s-300 text-lg-b4-m-300 color-black">
            <sd-radio
              type="radio"
              name="checkout-payment-mode"
              [(ngModel)]="activePaymentMode"
              [value]="formatBankCard(bankCardItem)"
              [disabled]="isItemDisabled"
            >
              <span class="color-black">оплата картой ****{{ bankCardItem.lastNumbers }}</span>
            </sd-radio>

            <sd-icon [type]="iconTypes.CARD" class="icon-size-m"></sd-icon>
          </div>
          @if (isItemDisabled) {
            <div class="color-black-warm-800">недоступно для этого типа услуг</div>
          }
        </div>
      }
    }
  }

  @for (otherItem of otherItems(); track otherItem.code) {
    <div class="payment-modes-list-item-wrapper">
      @let isItemDisabled = !!otherItem.disableWhenCanNotPayInplace && !canPayInplace();
      <div class="payment-modes-list-item text-b3-s-300 text-lg-b4-m-300 color-black">
        <sd-radio
          type="radio"
          name="checkout-payment-mode"
          [(ngModel)]="activePaymentMode"
          [value]="otherItem"
          [disabled]="isItemDisabled"
        >
          <span class="color-black">
            {{ otherItem.name }}
          </span>
        </sd-radio>
        <sd-icon [type]="getIcon(otherItem.code)" class="icon-size-m"></sd-icon>
      </div>
      @if (isItemDisabled) {
        <div class="color-black-warm-800">недоступно для этого типа услуг</div>
      }
    </div>
  }
</div>
